import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogContent, DialogDescription, DialogTitle, Textarea } from '@onward-delivery/design';

import { REVIEW_DECISIONS } from '../constants';

/**
 * Approve / Deny for the selected contractors, one at a time. Each step is titled with the carrier's name and takes
 * a note; Save records the decision and moves on, Skip moves on without one.
 *
 * @param {{ queue: import('../hooks').ReviewQueue|null, busy: boolean, onSubmit: Function, onSkip: Function,
 *   onCancel: Function }} props
 */
const ReviewDialog = ({ queue, busy, onSubmit, onSkip, onCancel }) => {
    const [note, setNote] = useState('');
    const row = queue?.rows[queue.index];
    const decision = REVIEW_DECISIONS[queue?.decision];

    // Each contractor starts with an empty note.
    useEffect(() => setNote(''), [row?.carrier_id]);

    return (
        <Dialog open={!!row} onOpenChange={(open) => !open && onCancel()}>
            <DialogContent className="max-w-lg">
                <DialogTitle className="text-lg font-semibold">
                    {row?.carrier?.business_name || 'Motor Carrier'}
                </DialogTitle>
                <DialogDescription className="text-sm text-muted">
                    {decision?.verb} compliance
                    {queue?.rows.length > 1 ? ` · ${queue.index + 1} of ${queue.rows.length}` : ''}
                </DialogDescription>
                <label className="mt-3 flex flex-col gap-1.5 text-[13px] font-medium text-slate-700">
                    Notes
                    <Textarea
                        value={note}
                        onChange={(event) => setNote(event.target.value)}
                        rows={4}
                        placeholder={
                            queue?.decision === 'DENIED' ? 'What does the Motor Carrier need to fix?' : 'Optional'
                        }
                    />
                </label>
                <div className="mt-4 flex justify-end gap-2">
                    {queue?.rows.length > 1 ? (
                        <Button variant="ghost" disabled={busy} onClick={onSkip}>
                            Skip
                        </Button>
                    ) : null}
                    <Button variant="outline" disabled={busy} onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button
                        variant={queue?.decision === 'DENIED' ? 'destructive' : 'primary'}
                        loading={busy}
                        disabled={busy}
                        onClick={() => onSubmit(note.trim())}
                    >
                        {decision?.verb}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ReviewDialog;
